import { Box, Container, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { ArrowForward } from "@mui/icons-material";

const SizeOfChurch = () => {
  return (
    <Box
      component="section"
      id="size-of-church"
      sx={{
        width: "100%",
        py: { xs: 10, md: 14 },
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          right: "90%",
          width: 600,
          height: 600,
          background:
            "radial-gradient(circle at center, rgba(77, 222, 128, 0.35), transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 9 } }}>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: 900,
              letterSpacing: -0.7,
              mb: 2,
            }}
          >
            Evangelism Changes as Your Church Grows
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "rgba(255,255,255,0.82)",
              maxWidth: 760,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Informal systems work well when one leader can personally know all the
            people, ministries and conversations involved. Growth changes that.
          </Typography>
        </Box>

        <Grid2 container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "100%",
                borderRadius: 5,
                p: { xs: 3, md: 4 },
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.14)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  right: -80,
                  top: -80,
                  width: 220,
                  height: 220,
                  borderRadius: "50%",
                  background: "rgba(77, 222, 128, 0.35)",
                  filter: "blur(2px)",
                }}
              />

              <Typography
                variant="h5"
                sx={{ color: "white", fontWeight: 900, mt: 1, mb: 3 }}
              >
                When Evangelism Is Still Simple
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5, mb: 3 }}>
                {[
                  "Leaders personally know most of the people being followed up",
                  "A small number of ministries are easy to coordinate informally",
                  "Important context can be shared through normal relationships",
                ].map((text) => (
                  <Box
                    key={text}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1.5,
                      p: 1.75,
                      borderRadius: 4,
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.10)",
                    }}
                  >
                    <ArrowForward
                      sx={{
                        mt: "3px",
                        fontSize: 18,
                        color: "rgba(255,255,255,0.70)",
                      }}
                    />
                    <Typography sx={{ color: "rgba(255,255,255,0.86)" }}>
                      {text}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{ typography: "h6", color: "rgba(255,255,255,0.82)" }}
              >
                In this environment, spreadsheets, conversations and personal
                memory may genuinely be enough.
              </Typography>
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "100%",
                borderRadius: 5,
                p: { xs: 3, md: 4 },
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.14)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  right: -90,
                  bottom: -90,
                  width: 240,
                  height: 240,
                  borderRadius: "50%",
                  background: "rgba(77, 222, 128, 0.35)",
                  filter: "blur(2px)",
                }}
              />

              <Typography
                variant="h5"
                sx={{ color: "white", fontWeight: 900, mt: 1, mb: 3 }}
              >
                When Evangelism Becomes Complex
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5, mb: 3 }}>
                {[
                  "There are more relationships than one leader can personally know",
                  "Multiple ministries and campaigns operate at the same time",
                  "Staff and volunteer teams each hold different pieces of the picture",
                  "Important strategic decisions depend on leaders knowing what is happening across the whole ministry",
                ].map((text) => (
                  <Box
                    key={text}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1.5,
                      p: 1.75,
                      borderRadius: 4,
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.10)",
                    }}
                  >
                    <ArrowForward
                      sx={{
                        mt: "3px",
                        fontSize: 18,
                        color: "rgba(255,255,255,0.70)",
                      }}
                    />
                    <Typography sx={{ color: "rgba(255,255,255,0.86)" }}>
                      {text}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{ typography: "h6", color: "rgba(255,255,255,0.82)" }}
              >
                PATHWAYS helps you turn your individual evangelistic efforts into one intentional pathway so you can see the big picture.
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Container>

      <Box sx={{ textAlign: "center", mb: { xs: 6, md: 9 } }}>
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 900,
            letterSpacing: -0.7,
            my: 10,
          }}
        >
          Built for Complex Ministries reaching Messy People.
        </Typography>
      </Box>
    </Box>
  );
};

export default SizeOfChurch;